const {PreviewTab} = require("../preview-tab/preview-tab");
const {StaticValueConfiguration} = require("./configuration/static-value-configuration");

const StaticValueStepTabs = {
    configuration: StaticValueConfiguration,
    preview: PreviewTab,
};

exports.StaticValueStepTabs = StaticValueStepTabs;
